import type { ComponentProps } from 'react';

const HeartOutlined = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3203 20.3312L11.2227 20.2413L4.37891 13.8859C3.17969 12.7726 2.5 11.2101 2.5 9.57337V9.44447C2.5 6.69447 4.45312 4.33509 7.15625 3.81947C8.69531 3.52259 10.2695 3.87806 11.5234 4.76087C11.875 5.01087 12.2031 5.29993 12.5 5.63197C12.6641 5.44447 12.8398 5.27259 13.0273 5.11243C13.1719 4.98743 13.3203 4.87025 13.4766 4.76087C14.7305 3.87806 16.3047 3.52259 17.8438 3.81556C20.5469 4.33118 22.5 6.69447 22.5 9.44447V9.57337C22.5 11.2101 21.8203 12.7726 20.6211 13.8859L13.7773 20.2413L13.6797 20.3312C13.3594 20.6281 12.9375 20.796 12.5 20.796C12.0625 20.796 11.6406 20.632 11.3203 20.3312ZM11.8398 7.70619C11.8242 7.69447 11.8125 7.67884 11.8008 7.66322L11.1055 6.88197L11.1016 6.87806C10.1992 5.86634 8.83594 5.4054 7.50781 5.65931C5.6875 6.00697 4.375 7.5929 4.375 9.44447V9.57337C4.375 10.6867 4.83984 11.7531 5.65625 12.5109L12.5 18.8663L19.3438 12.5109C20.1602 11.7531 20.625 10.6867 20.625 9.57337V9.44447C20.625 7.59681 19.3125 6.00697 17.4961 5.65931C16.168 5.4054 14.8008 5.87025 13.9023 6.87806C13.9023 6.87806 13.9023 6.87806 13.8984 6.88197C13.8945 6.88587 13.8984 6.88197 13.8945 6.88587L13.1992 7.66712C13.1875 7.68275 13.1719 7.69447 13.1602 7.71009C12.9844 7.88587 12.7461 7.98353 12.5 7.98353C12.2539 7.98353 12.0156 7.88587 11.8398 7.71009V7.70619Z"
        fill="#55657D"
      />
    </svg>
  );
};

export default HeartOutlined;
